


































































































import { Vue, Component } from 'vue-property-decorator'
import { Permission, Role } from '@/store/modules/role'

@Component
export default class RoleSelection extends Vue {
  selectedRoles: string[] = [];
  searchTerm = '';
  async mounted () {
    await this.$store.dispatch('loadAssignableRoles')
  }

  get roles () {
    const roles = this.$store.getters.getAssignableRoles
    const result = roles.map((role: Role) => {
      return {
        ...role,
        products: role.products.filter((product: any) => !product.disabled)
      }
    })
    return result.sort((a: Role, b: Role) => {
      if (a.displayIndex === b.displayIndex) {
        return a.name.localeCompare(b.name)
      }
      return b.displayIndex - a.displayIndex
    })
  }

  savePermissions () {
    this.$store.dispatch('addEvent', {
      description: 'Role slection confirmed',
      data: null,
      title: 'Role slection confirmed',
      eventType: 13,
      userAgent: navigator.userAgent,
      product: null,
      market: { key: this.$store.getters.getSelectedMarket },
      trackingKey: null
    })
    this.$bvModal
      .msgBoxConfirm(
        'Please note that you will be reauthenticated for your roles to take effect.',
        {
          size: 'ml',
          buttonSize: 'sm',
          okTitle: 'YES',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
          title: 'Confirm role assignment?'
        }
      )
      .then(value => {
        if (!value) {
          return
        }
        this.$store
          .dispatch('addRolesToUser', this.selectedRoles)
          .then(async () => {
            localStorage.removeItem('user-token')
            this.$store.dispatch('addEvent', {
              description: 'Role slection commited',
              data: null,
              title: 'Role slection commited',
              eventType: 14,
              userAgent: navigator.userAgent,
              product: null,
              market: { key: this.$store.getters.getSelectedMarket },
              trackingKey: null
            })
            this.$router.push({ path: '/sso' })
          })
      })
  }

  sortPermissions (permissions: Permission[]) {
    return JSON.parse(JSON.stringify(permissions)).sort(
      (a: Permission, b: Permission) => {
        return a.name < b.name ? -1 : a.name > b.name ? 1 : 0
      }
    )
  }

  toggleRoleSelection (roleKey: string) {
    const index = this.selectedRoles.indexOf(roleKey)
    if (index === -1) {
      this.selectedRoles.push(roleKey)
    } else {
      this.selectedRoles.splice(index, 1)
    }
  }

  closeModal () {
    (this.$refs.roleSelection as any).hide()
    location.reload()
  }
}
